// extracted by mini-css-extract-plugin
export default {"cstmPagination":"common_cstmPagination__IAHM9"};